import React from 'react'
import BankDataFieldsTest from '../components/test/BankDataFieldsTest'

const BankDataFieldsTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <BankDataFieldsTest />
    </div>
  )
}

export default BankDataFieldsTestPage